import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import config from 'react-observable-store'
import IssuesModel from '../models/IssuesModel'
import ProgramsModel from '../models/ProgramsModel'
import { Link } from 'react-router-dom'
import AuthModel from '../models/AuthModel'
import { Row, Col, Icon, Table, Button, Spin } from 'antd'
import MapLayerSwitcher from './MapLayerSwitcher'
import Gallery from './Gallery'
import PublicIssueFullTable from './PublicIssueFullTable'
import PublicIssueSimpleTable from './PublicIssueSimpleTable'

import Permissions from '../models/Permissions'

class PublicIssue extends Component {

    constructor(props) {
        super(props)

        // Init map
        this.map = IssuesModel.createMap(config.get('globals').olmap1, props.data.mapCenter, props.data.mapZoom)

        // Init UI form state
        this.state = {
            loading: true,
            programs: []
        }
    }

    loadOptions() {
        this.loading()
        ProgramsModel.findAll((programs) => {
            var state = Object.assign({}, this.state)
            state.programs = programs
            state.loading = false
            this.setState(state)
        });
    }

    componentDidMount() {
        const mapTarget = ReactDOM.findDOMNode(this.refs.map)
        this.map.setTarget(mapTarget)
        IssuesModel.olMap = this.map
        this.map.getView().setZoom(this.props.data.mapZoom)
        this.map.getView().setCenter(this.props.data.mapCenter)
        if (this.props.data.id) IssuesModel.putMarker(this.props.data.mapCenter, true)
        this.loading(false)
        this.loadOptions();
    }

    loading(toggle) {
        var state = Object.assign({}, this.state)
        state.loading = toggle
        this.setState(state)
    }

    downloadAttach(record) {
        var attachBaseUrl = IssuesModel.endpoint() + '/download'
        var url = attachBaseUrl+'/'+record.descricao+'?token=' + AuthModel.getAuthToken() + '&id='+record.id
        IssuesModel.download(record.descricao, url, record.mime)
    }

    rotateImage(record) {
        IssuesModel.rotateImage(record.id, () => {
            this.props.loadIssue(this.props.data.id)
        });
    }

    getImageUrl(record) {
        var baseUrl = config.get('globals').server.endpoint
        var url = baseUrl+'/'+record.ocorrencia_id+'/attach_a/'+record.descricao+'?t='+Math.random()
        return url;
    }

    getThumbUrl(record) {
        var baseUrl = config.get('globals').server.endpoint
        var url = baseUrl+'/'+record.ocorrencia_id+'/attach_a/thumb_'+record.descricao+'?t='+Math.random()
        return url;
    }

    onExport(format, mime) {
        this.loading(true)
        var url = IssuesModel.endpoint() + '/search/export/' + format + '?token=' + AuthModel.getAuthToken()
        url += '&id=' + this.props.data.id;
        IssuesModel.download(format, url, mime, () => {
            this.loading(false)
        })
    }

    render() {
        const columns = [
        {
            title: 'Descrição',
            dataIndex: 'descricao',
            key: 'descricao'
        },
        {
            title: 'Tipo',
            dataIndex: 'tipo_ficheiro_id',
            key: 'tipo_ficheiro_id',
            render: (text, r) => (
                <span>
                    {r.tipo_ficheiro_id === 1 ? 'Fotografia' :
                        (r.tipo_ficheiro_id === 2 ? 'Levantamento topográfico' : 'Outro')
                    }
                </span>
            )
        },
        {
            title: 'Data',
            dataIndex: 'data_referencia',
            key: 'data_referencia',
            render: (text, r) => (
                <span>
                    {r.data_referencia}
                </span>
            )
        },
        {
            title: 'Opções',
            key: 'action',
            render: (text, record) => (
                <div>
                  <a role="button" onClick={(e) => this.downloadAttach(record)}>
                      <Icon type="download" style={{color: 'green'}} />
                  </a>
                  {' '}
                  { record.tipo_ficheiro_id === 1 ? (
                      <a role="button" onClick={(e) => this.rotateImage(record)} title="Auto-rodar imagem">
                          <Icon type="reload" style={{color: 'brown'}} />
                      </a>
                  ) : null }
                </div>
            )
        }]
        this.props.data.attachments.map((item) => {
            item.key = item.id
            return item
        })
        var images = this.props.data.attachments.filter((item) => item.mime.indexOf('image') > -1)
        var galleryItems = images.map((item) => {
            return {
                original: this.getImageUrl(item),
                thumbnail: this.getThumbUrl(item)
            }
        });
        var pdfFilename = 'MROL_' + this.props.data.id+'.pdf';

        return (
            <div>

                <Row>
                    <Col xs={24} sm={6}></Col>
                    <Col xs={24} sm={14}><legend>
                        Detalhes da Ocorrência{' '}
                        { this.props.data.tecnico_utilizador_id === 2 ? <small>(submetida pelo público)</small> : null}
                    </legend></Col>
                </Row>

                <Row>
                    <Col xs={24} sm={6}></Col>
                    <Col xs={24} sm={14}>

                        { this.state.loading ? (<Spin style={{float: 'right'}} />) : (
                            <Button style={{float: 'right'}} type="default" onClick={(e) => this.onExport(pdfFilename, 'application/pdf')}>
                                pdf
                                <Icon type="file" />
                            </Button>
                        ) }

                        { !Permissions.isDenied('issues', 'update', this.props.data) ? (
                            <Link to={'/issue/' + this.props.data.id} style={{float: 'right', paddingTop: '5px'}}
                                className="ant-btn ant-btn-primary">
                                <Icon type="edit" />{' '}Editar
                            </Link>
                        ) : '' }

                        { this.props.data.tecnico !== 'public' ?
                            <PublicIssueFullTable
                                data={this.props.data}
                            />
                            : <PublicIssueSimpleTable 
                                data={this.props.data}
                            />
                        }

                        <div className="map" id="map" ref="map" style={{height: '252px', marginTop: '24px', marginBottom: '24px'}}>
                            <MapLayerSwitcher map={this.map} />
                        </div>

                        <div id="attachments">
                            <legend>Anexos</legend>
                            <Table dataSource={this.props.data.attachments} columns={columns} />
                        </div>

                        { galleryItems.length ? (
                            <Gallery items={galleryItems} />
                        ) : null }

                    </Col>
                </Row>

            </div>
        )
    }
}

export default PublicIssue;



// WEBPACK FOOTER //
// ./src/components/PublicIssue.js